import {MdDialog, MdDialogRef} from '@angular/material';
import {SongDetailComponent} from '../app/songs/song-detail/song-detail.component';

export class Helper {

    public  writersArray=[];
    public  creditsArray=[];
    public  libraries=[];
    dialogRef: MdDialogRef<SongDetailComponent>;
    public dialog: MdDialog;
    public setLink(item: any) {
        let link = "/";
        switch (item._type) {
            case "album":
            case "song":
            case "artist":
                link += item._type + '/' + (item.slug === null || item.slug.trim() === '' ? item.id : item.slug);
                break;
            case "account":
                link += item._type + '/' + (item.slug === null || item.screenname.trim() === '' ? item.id : item.screenname);
                break;
            case "playlist":
                if (item.type !== 'R') {
                    link += item._type + '/' + (item.slug === null || item.slug.trim() === '' ? item.id : item.slug);
                } else {
                    link = '/radio';
                }
                break;
        }
        return link;
    }

    public localTimeCheck(onlineOffline1?){
        let currentTime = new Date();

        if(localStorage.getItem('localTime')==null){
            localStorage.setItem('localTime',currentTime.getTime().toString());
        }

        let diff = currentTime.getTime()-parseInt(localStorage.getItem('localTime'));
        let mm = Math.floor(diff / 1000 / 60);
        let timerForLocalStorage = 10;
        if(!onlineOffline1){
            timerForLocalStorage = 100000000;
        }
        // On new day clear local storage data.
        if(mm>=timerForLocalStorage){

            ["P","G","B","F","Ac","M","WF","DM","R","MR"].forEach((arrayItem) => {
                localStorage.setItem(arrayItem, JSON.stringify([]));
            });

            localStorage.setItem("mostPlayed", JSON.stringify([]));
            localStorage.setItem("mostDownload", JSON.stringify([]));
            localStorage.setItem("mostNew", JSON.stringify([]));

            localStorage.setItem('localTime',""+currentTime.getTime().toString());
            return true;
        }
        return false;
    }

    setLocalStore($type,$data) {
        localStorage.setItem($type, JSON.stringify($data));
    }

    removeSlashItem(songs){
        if(songs){
            for(var i = 0 ;i<songs.length;i++) {
                if (songs[i].item._type == "song") {
                    if (typeof songs[i].item.credits === "object" && songs[i].item.credits != null) {
                        for (var j = 0; j < songs[i].item.credits.length; j++) {
                            songs[i].item.credits[j].credit_type = songs[i].item.credits[j].credit_type.replace("_", " ");
                            songs[i].item.credits[j].credit_type = songs[i].item.credits[j].credit_type.charAt(0).toUpperCase() + songs[i].item.credits[j].credit_type.slice(1);
                        }
                    }
                }
            }
        }
        return songs
    }

    removeSlash(songs) {

        if (songs) {
            for (var i = 0; i < songs.length; i++) {

                if (songs[i]._type == "song") {
                    if (typeof songs[i].credits === "object" && songs[i].credits != null) {
                        for (var j = 0; j < songs[i].credits.length; j++) {
                            // console.log(this.songs[i].credits);
                            songs[i].credits[j].credit_type = songs[i].credits[j].credit_type.replace("_", " ");
                            songs[i].credits[j].credit_type = songs[i].credits[j].credit_type.charAt(0).toUpperCase() + songs[i].credits[j].credit_type.slice(1);
                        }
                    }
                }
            }
        }
        return songs;
    }
    removeDuplicatCredits(songs) {

        for (var i = 0; i < songs.length; i++) {
            if (songs[i]._type == "song") {

                this.writersArray.length = 0;
                if(songs[i].writers) {
                    songs[i].writers.forEach((item, index) => {
                        if (index !== songs[i].writers.findIndex(i => i.writer === item.writer)) {
                            this.writersArray.push(songs[i].writers[index]);
                            songs[i].writers.splice(index, 1);
                        }
                    });
                    songs[i].writers.forEach((item, index) => {
                        if (index !== songs[i].writers.findIndex(i => i.writer === item.writer)) {
                            this.writersArray.push(songs[i].writers[index]);
                            songs[i].writers.splice(index, 1);
                        }
                    });
                    songs[i].writers.forEach((item, index) => {
                        if (index !== songs[i].writers.findIndex(i => i.writer === item.writer)) {
                            this.writersArray.push(songs[i].writers[index]);
                            songs[i].writers.splice(index, 1);
                        }
                    });
                    songs[i].writers.forEach((item, index) => {
                        if (index !== songs[i].writers.findIndex(i => i.writer === item.writer)) {
                            this.writersArray.push(songs[i].writers[index]);
                            songs[i].writers.splice(index, 1);
                        }
                    });
                }
                this.creditsArray.length = 0;
                if(songs[i].credits) {
                    songs[i].credits.forEach((item, index) => {
                        if (index !== songs[i].credits.findIndex(i => i.credit_type === item.credit_type)) {
                            this.creditsArray.push(songs[i].credits[index]);
                            songs[i].credits.splice(index, 1);
                        }
                    });
                    songs[i].credits.forEach((item, index) => {
                        if (index !== songs[i].credits.findIndex(i => i.credit_type === item.credit_type)) {
                            this.creditsArray.push(songs[i].credits[index]);
                            songs[i].credits.splice(index, 1);
                        }
                    });
                    songs[i].credits.forEach((item, index) => {
                        if (index !== songs[i].credits.findIndex(i => i.credit_type === item.credit_type)) {
                            this.creditsArray.push(songs[i].credits[index]);
                            songs[i].credits.splice(index, 1);
                        }
                    });
                    songs[i].credits.forEach((item, index) => {
                        if (index !== songs[i].credits.findIndex(i => i.credit_type === item.credit_type)) {
                            this.creditsArray.push(songs[i].credits[index]);
                            songs[i].credits.splice(index, 1);
                        }
                    });
                }

                if (this.creditsArray && this.creditsArray.length) {
                    for (var j = 0; j < this.creditsArray.length; j++) {
                        for (var k = 0; k < songs[i].credits.length; k++) {
                            if (songs[i].credits[k].credit_type == this.creditsArray[j].credit_type) {
                                if (!(songs[i].credits[k].name.includes(this.creditsArray[j].name))) {

                                    if (!songs[i].credits[k].values) {
                                        songs[i].credits[k]["values"] = [];
                                    }
                                    if (!(songs[i].credits[k].values.includes(songs[i].credits[k].name))) {
                                        songs[i].credits[k].values.push(songs[i].credits[k].name);
                                    }
                                    if (!(songs[i].credits[k].values.includes(this.creditsArray[j].name))) {
                                        songs[i].credits[k].values.push(this.creditsArray[j].name);
                                    }
                                }
                            }
                        }
                    }
                }
                for (var k = 0; k < songs[i].credits.length; k++) {

                    if (!songs[i].credits[k].values) {
                        songs[i].credits[k]["values"] = [];
                    }
                    if (!(songs[i].credits[k].values.includes(songs[i].credits[k].name))) {
                        var locationPartt = songs[i].credits[k].name.split(",");

                        for (var p = 0; p < locationPartt.length; p++) {
                            locationPartt[p].replace(",", "");
                            songs[i].credits[k].values.push(locationPartt[p]);
                        }
                    }
                    if (songs[i].credits[k].location && songs[i].credits[k].location != null) {
                        songs[i].credits[k]["locations"] = [];

                        var locationParts = songs[i].credits[k].location.split(",");
                        for (var m = 0; m < locationParts.length; m++) {
                            if (!(locationParts[m].includes("."))) {
                                songs[i].credits[k].locations.push(locationParts[m]);
                            }
                            else {
                                var locationParts2 = locationParts[m].split(".");
                                for (var n = 0; n < locationParts2.length; n++) {
                                    songs[i].credits[k].locations.push(locationParts2[n]);
                                }
                            }
                        }
                    }
                }

                //publisher array making
                if (!songs[i].publishers) {
                    songs[i]["publisherss"] = [];
                    if (songs[i].publisher) {
                        var locationParttt = songs[i].publisher.split(",");

                        for (var p = 0; p < locationParttt.length; p++) {
                            locationParttt[p].replace(",", "");
                            songs[i].publisherss.push(locationParttt[p]);
                        }
                    }
                } else {
                    songs[i]["publisherss"] = [];
                    for (let m = 0; m < songs[i].publishers.length; m++) {
                        if (songs[i].publishers[m].publisher) {
                            songs[i].publisherss.push(songs[i].publishers[m].publisher);
                        }
                    }
                }

            }
        }

        return songs;
    }

    removeDuplicatCreditsItem(songs){
        this.libraries = songs;
        for(var i = 0 ; i<this.libraries.length; i++){
            if (this.libraries[i].item._type == "song") {

                this.writersArray.length = 0;
                // alert("writers before" + this.songs[i].writers.length);
                this.libraries[i].item.writers.forEach((item, index) => {
                    if (index !== this.libraries[i].item.writers.findIndex(i => i.writer === item.writer)) {
                        this.writersArray.push(this.libraries[i].item.writers[index]);
                        this.libraries[i].item.writers.splice(index, 1);
                    }
                });
                this.libraries[i].item.writers.forEach((item, index) => {
                    if (index !== this.libraries[i].item.writers.findIndex(i => i.writer === item.writer)) {
                        this.writersArray.push(this.libraries[i].item.writers[index]);
                        this.libraries[i].item.writers.splice(index, 1);
                    }
                });
                this.libraries[i].item.writers.forEach((item, index) => {
                    if (index !== this.libraries[i].item.writers.findIndex(i => i.writer === item.writer)) {
                        this.writersArray.push(this.libraries[i].item.writers[index]);
                        this.libraries[i].item.writers.splice(index, 1);
                    }
                });
                this.libraries[i].item.writers.forEach((item, index) => {
                    if (index !== this.libraries[i].item.writers.findIndex(i => i.writer === item.writer)) {
                        this.writersArray.push(this.libraries[i].item.writers[index]);
                        this.libraries[i].item.writers.splice(index, 1);
                    }
                });
                // alert("writers after" + this.songs[i].writers.length);
                // alert("Spliced writers after" + this.writersArray.length);

                this.creditsArray.length = 0;
                this.libraries[i].item.credits.forEach((item, index) => {
                    if (index !== this.libraries[i].item.credits.findIndex(i => i.credit_type === item.credit_type)) {
                        this.creditsArray.push(this.libraries[i].item.credits[index]);
                        this.libraries[i].item.credits.splice(index, 1);
                    }
                });
                this.libraries[i].item.credits.forEach((item, index) => {
                    if (index !== this.libraries[i].item.credits.findIndex(i => i.credit_type === item.credit_type)) {
                        this.creditsArray.push(this.libraries[i].item.credits[index]);
                        this.libraries[i].item.credits.splice(index, 1);
                    }
                });
                this.libraries[i].item.credits.forEach((item, index) => {
                    if (index !== this.libraries[i].item.credits.findIndex(i => i.credit_type === item.credit_type)) {
                        this.creditsArray.push(this.libraries[i].item.credits[index]);
                        this.libraries[i].item.credits.splice(index, 1);
                    }
                });
                this.libraries[i].item.credits.forEach((item, index) => {
                    if (index !== this.libraries[i].item.credits.findIndex(i => i.credit_type === item.credit_type)) {
                        this.creditsArray.push(this.libraries[i].item.credits[index]);
                        this.libraries[i].item.credits.splice(index, 1);
                    }
                });

                if (this.creditsArray && this.creditsArray.length) {
                    for (var j = 0; j < this.creditsArray.length; j++) {
                        for (var k = 0; k < this.libraries[i].item.credits.length; k++) {
                            if (this.libraries[i].item.credits[k].credit_type == this.creditsArray[j].credit_type) {
                                if (!(this.libraries[i].item.credits[k].name.includes(this.creditsArray[j].name))) {

                                    if (!this.libraries[i].item.credits[k].values) {
                                        this.libraries[i].item.credits[k]["values"] = [];
                                    }
                                    if (!(this.libraries[i].item.credits[k].values.includes(this.libraries[i].item.credits[k].name))) {
                                        this.libraries[i].item.credits[k].values.push(this.libraries[i].item.credits[k].name);
                                    }
                                    if (!(this.libraries[i].item.credits[k].values.includes(this.creditsArray[j].name))) {
                                        this.libraries[i].item.credits[k].values.push(this.creditsArray[j].name);
                                    }
                                }
                            }
                        }
                    }
                }
                for (var k = 0; k < this.libraries[i].item.credits.length; k++) {

                    if (!this.libraries[i].item.credits[k].values) {
                        this.libraries[i].item.credits[k]["values"] = [];
                    }
                    if (!(this.libraries[i].item.credits[k].values.includes(this.libraries[i].item.credits[k].name))) {
                        var locationPartt = this.libraries[i].item.credits[k].name.split(",");

                        for (var p = 0; p < locationPartt.length; p++) {
                            locationPartt[p].replace(",", "");
                            this.libraries[i].item.credits[k].values.push(locationPartt[p]);
                        }
                    }
                    if (this.libraries[i].item.credits[k].location && this.libraries[i].item.credits[k].location != null) {
                        this.libraries[i].item.credits[k]["locations"] = [];

                        var locationParts = this.libraries[i].item.credits[k].location.split(",");
                        for (var m = 0; m < locationParts.length; m++) {
                            if (!(locationParts[m].includes("."))) {
                                this.libraries[i].item.credits[k].locations.push(locationParts[m]);
                            }
                            else {
                                var locationParts2 = locationParts[m].split(".");
                                for (var n = 0; n < locationParts2.length; n++) {
                                    this.libraries[i].item.credits[k].locations.push(locationParts2[n]);
                                }
                            }
                        }
                    }
                }

                //publisher array making
                if (!this.libraries[i].publishers) {
                    this.libraries[i].item["publisherss"] = [];
                    if (this.libraries[i].item.publisher) {
                        var locationParttt = this.libraries[i].item.publisher.split(",");

                        for (var p = 0; p < locationParttt.length; p++) {
                            locationParttt[p].replace(",", "");
                            this.libraries[i].item.publisherss.push(locationParttt[p]);
                        }
                    }
                }else {
                    this.libraries[i]["publisherss"] = [];
                    for(let m = 0; m < this.libraries[i].publishers.length; m++){
                        if(this.libraries[i].publishers[m].publisher){
                            this.libraries[i].publisherss.push(this.libraries[i].publishers[m].publisher);
                        }
                    }
                }
            }
        }

        return this.libraries;
    }

    openSongDetail(event,song) {
        event.stopPropagation();
        event.preventDefault();
        var width = '', height = '';
        var browserZoomLevel = Math.round(window.devicePixelRatio * 100);

        width = '37%';
        this.dialogRef = this.dialog.open(SongDetailComponent, {
            // disableClose: false,
            width: width
        });
        this.dialogRef.componentInstance.song = song;
        return false;
    }
}



// WEBPACK FOOTER //
// ./src/app/helper.ts